export var EReport;
(function (EReport) {
    EReport[EReport["ReportForLogicDepartment"] = 0] = "ReportForLogicDepartment";
    EReport[EReport["ReportForAPNSettings"] = 1] = "ReportForAPNSettings";
    EReport[EReport["ReportForOrderData"] = 2] = "ReportForOrderData";
    EReport[EReport["ReportForDiscountCodes"] = 3] = "ReportForDiscountCodes";
    EReport[EReport["ReportForBssSubsId"] = 4] = "ReportForBssSubsId";
})(EReport || (EReport = {}));
